import React from 'react';
import moment from 'moment';
import { Button } from 'antd';
import { header as strings } from 'ui/constants/strings';

const Header = (props) => {
  const { onLogoutClick, showAdminTool, onAdminToolClick } = props;
  return (
    <div className='component-header'>
      <div className='component-header__title'>
      </div>
      <div className='component-header__time'>
        {moment().format(strings.timeFormat)}
      </div>
      <div className='component-header__setting'>
        <Button type="link" icon="logout" size={'small'} onClick={() => {onLogoutClick()}}>
          { strings.logoutButtom}
        </Button>
      </div>
      {/* <div className='component-header__setting'>
        <Button type="link" icon="setting" size={'small'} onClick={() => {onSettingClick()}}>
          { strings.settingButtom}
        </Button>
      </div> */}
      {
        showAdminTool &&
        <div className='component-header__setting'>
          <Button type="link" icon="tool" size={'small'} onClick={() => {onAdminToolClick()}}>
            { 'admin tool '}
          </Button>
        </div>
      }
    </div>
  )
}
export default Header;
